import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollWindowToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Reset scroll on route changes. Hash links scroll to the target section instead.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace('#', ''));
      const go = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          scrollWindowToTop();
        }
      };
      // Wait for page transition / content mount
      const t = window.setTimeout(go, 80);
      return () => window.clearTimeout(t);
    }

    scrollWindowToTop();
    // Re-assert after route transition animation settles
    const t = window.setTimeout(scrollWindowToTop, 400);
    return () => window.clearTimeout(t);
  }, [pathname, hash, key]);

  return null;
}

/** Call from nav clicks when already on the target route. */
export function scrollToTopNow(smooth = false) {
  window.scrollTo({ top: 0, left: 0, behavior: smooth ? 'smooth' : 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
